import {
  faFilePdf,
  faFileWord,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getFileExtensionType } from "./attachment-utils";

function MediaPlaceholder({
  children,
  onClick,
  icon,
  isAttachmentSelected,
}) {
  return (
    <div
      onClick={onClick}
      className={`h-[80px] w-[80px] bg-brand-subtle flex items-center justify-center rounded-md cursor-pointer shadow-xs ${
        isAttachmentSelected
          ? "border-4 border-brand"
          : "border border-secondary"
      }`}
    >
      <h4 className="text-brand font-extrabold flex flex-col items-center justify-center">
        <FontAwesomeIcon icon={icon} size="2x" />

        {children}
      </h4>
    </div>
  );
}

export function Thumbnail({
  attachment,
  handleAttachmentClick,
  isAttachmentSelected,
}) {
  switch (getFileExtensionType(attachment.fileName)) {
    case "pdf":
      return (
        <MediaPlaceholder
          onClick={(e) => {
            e.preventDefault();
            handleAttachmentClick(attachment);
          }}
          icon={faFilePdf}
          isAttachmentSelected={isAttachmentSelected}
        >
          PDF
        </MediaPlaceholder>
      );
    case "doc":
    case "docx":
      return (
        <MediaPlaceholder
          onClick={(e) => {
            e.preventDefault();
            handleAttachmentClick(attachment);
          }}
          icon={faFileWord}
          isAttachmentSelected={isAttachmentSelected}
        >
          DOC
        </MediaPlaceholder>
      );
    case "mp4":
    case "mov":
    case "webm":
    case "mpeg":
    case "ogv":
    case "ts":
    case "avi":
      return (
        <video
          type={`video/${attachment.fileType}`}
          onClick={(e) => {
            e.preventDefault();
            handleAttachmentClick(attachment);
          }}
          src={attachment.fileLink}
          className={`object-cover h-[80px] w-[80px] rounded-md bg-white shadow-xs cursor-pointer ${
            isAttachmentSelected
              ? "border-4 border-brand"
              : "border border-secondary"
          }`}
        />
      );
    default:
      return (
        <img
          src={attachment.fileLink}
          className={`object-cover h-[80px] w-[80px] rounded-md bg-white shadow-xs cursor-pointer ${
            isAttachmentSelected
              ? "border-4 border-brand"
              : "border border-secondary"
          }`}
          onClick={(e) => {
            e.preventDefault();
            handleAttachmentClick(attachment);
          }}
        />
      );
  }
}
